<template>
  <el-button :type="buttontype" icon="el-icon-s-order" @click="Save" v-loading.fullscreen.lock="fullscreenLoading">{{buttonname}}</el-button>
</template>

<script>
export default {
  name: 'SaveButton',
  data () {
    return {
      fullscreenLoading: false
    }
  },
  props: {
    url: {
      type: String
    },
    back: {
      type: String,
      defalut: ''
    },
    buttonname: {
      type: String,
      default: '保存'
    },
    buttontype: {
      type: String,
      default: 'success'
    }
  },
  methods: {
    Save: function() {
      var form = null
      var parent = this.$parent
      while (form == null) {
        form = parent.form
        if (form != null) {
          break
        } else {
          parent = parent.$parent
        }
      }
      if (form.Save != null) {
        form.Save()
      } else {
        parent.$refs['form'].validate((valid) => {
          if (valid) {
            this.fullscreenLoading = true
            this.$http.post(this.url, form)
              .then(res => {
                console.log(res.data)
                if (res.data.Code === 0) {
                  this.$message({
                    message: '保存成功',
                    type: 'success'
                  })
                  console.log('保存成功')
                  if (this.back != "0"){
                    this.$router.push('/main' + this.back)
                  }else {
                    this.$emit('saveSucess')
                  }
                } else {
                  this.$message({
                    message: res.data.Error,
                    type: 'error'
                  })
                }
                this.fullscreenLoading = false
              })
              .catch(err => {
                console.log(err)
                this.$message({
                  message: '保存失败',
                  type: 'error'
                })
                this.fullscreenLoading = false
              })
          } else {
            console.log('error submit!!')
            return false;
          }
        })
      }
    }
  }
}
</script>

<style>
</style>
